module.exports = __webpack_public_path__ + "static/media/bisonLogo.b96e6e2e.png";